import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ConfirmationModal } from '../../../components/ConfirmationModal';

interface IProps {
  show: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

export const ResetWorkspaceConfirmationModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <ConfirmationModal
      showModal={props.show}
      confirmationHeader={'reset_workspace'}
      confirmationQuestion={
        <div>
          <p>{t('reset_workspace_confirmation_message')}</p>
          <ul>
            <li>{t('reset_list_1')}</li>
            <li>{t('reset_list_2')}</li>
            <li>{t('reset_list_3')}</li>
          </ul>
          <p>{t('reset_workspace_confirmation_message2')}</p>
        </div>
      }
      onCancel={props.onCancel}
      onConfirm={props.onConfirm}
      confirmationYes={'reset'}
      loaderKey='reset-workspace-button'
    />
  );
});
